import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor(private readonly translate: TranslateService) {
  }

  getLocale(): string {
    return this.translate.instant(`locale.${this.translate.currentLang}`);
  }
}
